/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card__login[_ngcontent-%COMP%]{margin:1.5rem 0;padding:1.5rem}.card__login[_ngcontent-%COMP%]   mat-card-content[_ngcontent-%COMP%]{margin-top:1.5rem;display:flex;flex-direction:column}.card__login[_ngcontent-%COMP%]   mat-card-actions[_ngcontent-%COMP%]{margin:0}"];
export { styles as styles };
